import { gql } from "@apollo/client";

export const getSubmissionErrorsInfo = gql`
    query getSubmissionErrorsInfo($lensId: ID!) {
        getMyLensesSubmissionErrors(input: { lensId: $lensId }) {
            submissionErrorsList {
                heading
                message
            }
        }
        getLens(input: { lensId: $lensId }) {
            lens {
                id # ID needed for cache
                rejectionErrors {
                    hasSubmissionErrors
                    messagesList
                    heading
                    violatingComponentsList
                }
            }
        }
    }
`;
